const isCycleLabel = (value) => /initial|surveillance|recert|re-cert|special audit|transfer/i.test(String(value || ''));

const isScheduleModality = (value) => /^(on[ -]?site|off[ -]?site|online|remote|hybrid)$/i.test(String(value || '').trim());

const lastScopeLabelPart = (scopeLabel = '') => String(scopeLabel)
  .split('/')
  .map((part) => part.trim())
  .filter(Boolean)
  .pop() || '';

// The workflow's Audit Type is the certification cycle (Initial, Surveillance,
// Recertification), not the schedule modality such as On-site or Online.
export const resolveActiveCycleAuditType = ({ scopeContext = {}, scopeLabel = '', apiAuditType = '' } = {}) => {
  const candidates = [
    scopeContext?.serviceItemName,
    scopeContext?.serviceItem,
    scopeContext?.cycleLabel,
    scopeContext?.auditCycleName,
    lastScopeLabelPart(scopeLabel),
    apiAuditType,
    scopeContext?.auditType,
  ];
  return candidates.find((value) => isCycleLabel(value) && !isScheduleModality(value)) || '';
};

// Supports both direct controller payloads and the application's wrapped
// `{ data: { certificateNumber } }` response convention.
export const extractCertificateNumberDefault = (response) => {
  const payload = response?.data?.data || response?.data || response || {};
  return String(payload?.certificateNumber || payload?.certificate_number || '').trim();
};
